const data = [
    {
        id: 1,
        text: "Buy Xmas Chickens",
        day: "Dec 24th",
        time: "2:00pm",
        reminder: true,
      },
      {
        id: 2,
        text: "Meeting at School",
        day: "Jan 3rd",
        time: "11:30am",
        reminder: true,
      },
      {
        id: 3,
        text: "Food Shopping",
        day: "Feb 5th",
        time: "2:30pm",
        reminder: false,
      }
    
];

export default data;